import CommentMedicalIcon from 'assets/svgs/CommentMedicalIcon';
import DefaultAvatarIcon from 'assets/svgs/DefaultAvatarIcon';
import { MobileQuestionAddAnswerModal } from 'components/Modals/Mobile/QuestionAddAnswerModal';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/interfaces';
import { apiGetContentAnswers } from 'shared/api/content';
import { getArrFromString } from 'shared/utils/utils';
import { MobileCardQuestionDetailAnswer } from './CardAnswer';

import './index.styles.scss';

interface Props {
  data: any;
  detectScroll: boolean;
  onViewBotProfile: (userId) => void;
}

export const MobileFeedCardBookMark = ({
  data,
  detectScroll,
  onViewBotProfile
}: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { userInfo } = useSelector((state: RootState) => state.profile);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const [showAddAnswer, setShowAddAnswer] = useState(false);
  const [showTopShadow, setShowTopShadow] = useState(false);

  const [otherAnswers, setOtherAnswers] = useState<Array<any>>([]);
  const [hasMoreOther, setHasMoreOther] = useState(true);
  const [lastIdOther, setLastIdOther] = useState(0);
  const [isLoadingOther, setIsLoadingOther] = useState(false);

  useEffect(() => {
    initAnswers();
  }, []);

  useEffect(() => {
    (function (d, s, id) {
      var js,
        sjs = d.getElementsByTagName(s)[0];
      if (sjs && sjs.parentNode) {
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://sdk.snapkit.com/js/v1/create.js';
        sjs.parentNode.insertBefore(js, sjs);
      } else {
        console.log('--- failed to load snap sdk');
      }
    })(document, 'script', 'snapkit-creative-kit-sdk');
  }, []);

  const initAnswers = () => {
    const tmpArrAnswerId = getArrFromString(data.answer_ids, ';;;');
    const tmpArrAnswerText = getArrFromString(data.answer_texts, ';;;');
    const tmpArrAnswerAudio = getArrFromString(data.answer_audios, ';;;');
    const tmpArrAnswerCreatorId = getArrFromString(
      data.answer_creator_ids,
      ';;;'
    );
    const tmpArrAnswerCreatorName = getArrFromString(
      data.answer_creator_names,
      ';;;'
    );
    const tmpArrAnswerCreatorImage = getArrFromString(
      data.answer_creator_images,
      ';;;'
    );
    const tmpArrLike = getArrFromString(data.answer_likes, ';;;');
    const tmpArrDisLike = getArrFromString(data.answer_dislikes, ';;;');
    const tmpArrUserLikes = getArrFromString(data.answer_user_likes, ';;;');
    const tmpArrAnswerPoint = getArrFromString(data.answer_points, ';;;');

    setOtherAnswers(
      tmpArrAnswerId.map((id, index) => {
        return {
          answer_id: tmpArrAnswerId[index],
          answer_text: tmpArrAnswerText[index],
          answer_audio: tmpArrAnswerAudio[index],
          answer_creator_id: tmpArrAnswerCreatorId[index],
          answer_creator_name: tmpArrAnswerCreatorName[index],
          answer_creator_image: tmpArrAnswerCreatorImage[index],
          points: tmpArrAnswerPoint[index],
          answer_likes: tmpArrLike[index],
          answer_dislikes: tmpArrDisLike[index],
          user_like: tmpArrUserLikes[index]
        };
      })
    );
  };

  const loadAnswers = async () => {
    if (!isLoadingOther && hasMoreOther) {
      const res = await apiGetContentAnswers({
        bookmark: data.id,
        limit: 10,
        offset: otherAnswers.length
      });

      if (res.success) {
        setOtherAnswers((prev) => [...prev, ...res.data]);
        setLastIdOther(res.lastId);
        setHasMoreOther(res.hasMoreOther);
      }
    }
  };

  const handleScroll = (e) => {
    if (detectScroll) {
      // hide nav bar
      const scrollTop = e.target.scrollTop;
      setLastScrollTop(scrollTop);

      if (scrollTop < lastScrollTop) {
        document
          .getElementById('mobile_body')
          ?.setAttribute('class', 'mobile_body normal_mobile_body');
        document
          .getElementById('mobile_tab')
          ?.setAttribute('class', 'mobile_tab active_nav');
        setShowTopShadow(false);
      } else {
        document
          .getElementById('mobile_body')
          ?.setAttribute('class', 'mobile_body expanded_mobile_body');
        document
          .getElementById('mobile_tab')
          ?.setAttribute('class', 'mobile_tab hidden_nav');
        setShowTopShadow(true);
      }
    }

    if (scrollRef.current) {
      const { scrollTop, clientHeight, scrollHeight } = scrollRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 0.5) {
        loadAnswers();
      }
    }
  };

  const onAddAnswer = () => {
    setShowAddAnswer(true);
  };

  const onAddNewAnswerToUI = (newAnswerTxt, newAnswerId) => {
    const newAnswer = {
      answer_audio: null,
      answer_creator_id: userInfo?.id,
      answer_creator_image: userInfo?.image,
      answer_creator_name: userInfo?.name,
      answer_dislikes: 0,
      answer_id: newAnswerId,
      answer_likes: 0,
      answer_text: newAnswerTxt,
      points: 0,
      user_like: -1
    };

    setOtherAnswers((prev) => [newAnswer, ...prev]);
  };

  const renderBody = () => {
    return (
      <div className="mobile_question_detail_body">
        {renderQuestion()}
        {renderUserInfo()}
        {renderSubActions()}
        {(otherAnswers.length > 0 || !!data.ai_answer) &&
          renderVerticalDivider()}
        {renderImage()}
        {renderTopAnswer()}
        {renderAnswers()}
      </div>
    );
  };

  const renderQuestion = () => {
    return (
      <div className="bookmark_question_title font-bold">{data.question}</div>
    );
  };

  const renderUserInfo = () => {
    return (
      <div
        className="user_info row_align_items font-regular"
        onClick={() => {
          onViewBotProfile(data.creator_id);
        }}
      >
        <span className="font-regular">{`Shared By`}</span>
        {data.creator_image && data.creator_image.startsWith('https') ? (
          <img src={data.creator_image} className="user_img" />
        ) : (
          <DefaultAvatarIcon size={26} />
        )}
        <span className="font-bold">{`${
          data.creator_name ?? 'Anonymous'
        }`}</span>
      </div>
    );
  };

  const renderSubActions = () => {
    return (
      <div className="row_align_items" style={{ marginTop: 8 }}>
        <div className="sub_item">
          <div style={{ fontSize: 16 }}>👀</div>
          <div className="font-medium font14">{data.seen_total ?? 0}</div>
          <div className="font-regular font14" style={{ opacity: 0.6 }}>
            views
          </div>
        </div>
        <div className="sub_item" onClick={onAddAnswer}>
          <CommentMedicalIcon size={20} />
          <div className="font-medium font14">Add Answer</div>
        </div>
      </div>
    );
  };

  const renderVerticalDivider = () => {
    return <div className="vertical_divider"></div>;
  };

  const renderImage = () => {
    if (data.images && data.images.startsWith('https')) {
      return (
        <div className="normal_question_image">
          <img
            src={data.images}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>
      );
    } else {
      return <></>;
    }
  };

  const renderTopAnswer = () => {
    return <pre className="top_answer_txt font-regular">{data.ai_answer}</pre>;
  };

  const renderAnswers = () => {
    return (
      <div className="answer_list">
        {otherAnswers.length > 0 && (
          <div className="other_answer_title font-bold font18">
            Other Answers
          </div>
        )}
        {otherAnswers.map((item, index) => {
          return (
            <MobileCardQuestionDetailAnswer
              key={`answer_card_${item.answer_id}`}
              data={item}
              isTopAnswer={false}
            />
          );
        })}
      </div>
    );
  };

  const renderAddAnswerModal = () => {
    return (
      <MobileQuestionAddAnswerModal
        open={showAddAnswer}
        data={data}
        onClose={() => {
          setShowAddAnswer(false);
        }}
        onSuccess={(newAnswerTxt, newAnswerId) => {
          setShowAddAnswer(false);
          onAddNewAnswerToUI(newAnswerTxt, newAnswerId);
        }}
      />
    );
  };

  const renderBottomShadow = () => {
    return <div className="did_know_bottom"></div>;
  };

  const renderTestSnapChatShareBtn = () => {
    return (
      <div
        className="snapchat-creative-kit-share"
        data-share-url="https://kit.snapchat.com/"
        data-theme="dark"
        data-size="large"
        data-text="false"
      ></div>
    );
  };

  const renderTopShadow = () => {
    return <div className="top_shadow"></div>;
  };

  return (
    <div className="mobile_card_bookmark">
      {showTopShadow && renderTopShadow()}
      <div className="card_container" ref={scrollRef} onScroll={handleScroll}>
        {renderBody()}
        {renderBottomShadow()}
      </div>
      {renderAddAnswerModal()}
    </div>
  );
};
